/** The drawn status dot: cyan for waiting, coral for a problem. It leads a
 *  problem line in place of the banned left-border alert stripe. Decorative;
 *  the words beside it say the state. */
export function StatusDot({ tone }: { tone: "waiting" | "problem" }) {
  return (
    <svg className={`queue-dot queue-dot-${tone}`} viewBox="0 0 10 10" aria-hidden="true">
      <circle cx="5" cy="5" r="4" />
    </svg>
  );
}
